/**
 * Normalizes `NEXT_PUBLIC_GTM_VIEW` into a URL fragment.
 *
 * The env var is authored loosely (leading `+`, quotes, `?` or `&` prefix), so
 * this tolerates all of those shapes.
 */
const normalizeGtmView = gtmView => {
  if (!gtmView) {
    return '';
  }
  let normalized = gtmView.trim();
  while (normalized.startsWith('+')) {
    normalized = normalized.slice(1).trim();
  }
  while (normalized.length >= 2 && (normalized.startsWith("'") && normalized.endsWith("'") || normalized.startsWith('"') && normalized.endsWith('"') || normalized.startsWith('`') && normalized.endsWith('`'))) {
    normalized = normalized.slice(1, -1).trim();
  }
  if (!normalized) {
    return '';
  }
  return normalized.startsWith('&') ? normalized : `&${normalized.replace(/^\?/, '')}`;
};
/**
 * Builds the GTM container URL, preserving the GTM *environment* parameters
 * that `NEXT_PUBLIC_GTM_VIEW` carries (`gtm_auth`, `gtm_preview`,
 * `gtm_cookies_win`).
 *
 * Both apps register it as their GTM script's `src`. Without it, any
 * environment that sets `NEXT_PUBLIC_GTM_VIEW` would silently fall back to the
 * live container.
 */
const buildGtmUrl = (path, gtmId, gtmView) => `https://www.googletagmanager.com/${path}?id=${gtmId}${normalizeGtmView(gtmView)}`;

export { buildGtmUrl };
